module.exports = __webpack_public_path__ + "static/assets/f87fa4a5c09ad5c3798d182d671e2f18.jpg";